/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
    toggleSidebar({ state, commit }) {
        commit('setSidebarCollapsed', !state.isSidebarCollapsed)
    },
    collapseSidebar({ commit }) {
        commit('setSidebarCollapsed', true)
    },
    expandSidebar({ commit }) {
        commit('setSidebarCollapsed', false)
    },
    openMobileMenu({ commit }) {
        commit('setMobileMenuOpen', true)
    },
    closeMobileMenu({ commit }) {
        commit('setMobileMenuOpen', false)
    },
    toggleMobileMenu({ state, commit }) {
        commit('setMobileMenuOpen', !state.isMobileMenuOpen)
    }
}
